<template>
    <div class="hero flex">
        <div class="graphic" :class="`publisher-${publisher.id}`"></div>
        <div class="ff details flex flex-column flex-center">
            <div class="logo flex">
                <img :src="publisher.data.wordmark" />
            </div>
            <div class="ff tagline flex flex-column flex-center">
                <h1 v-if="publisher.data.introduction">{{publisher.data.introduction}}</h1>
                <h1 v-else v-html="headline"></h1>
                <div class="flex flex-align login-options">
                    <div class="button" @click="login">Sign In</div>
                    <a v-if="publisher.data.learn_more_url" :href="publisher.data.learn_more_url" target="_blank" class="button grey">Learn More</a>
                </div>
            </div>
            <div class="flex flex-align">
                <a class="disclaimer" v-if="publisher.data.terms" :href="publisher.data.terms" target="_blank">Terms of Service</a>
                <a class="disclaimer" v-if="publisher.data.privacy" :href="publisher.data.privacy" target="_blank">Privacy Policy</a>
            </div>
        </div>
    </div>
</template>

<script>
    const clients = {
        // 60011900374304: '', // Chairseven
        600016620787: 'd3bf6592-ed83-4a4d-ada4-3d2787d578d3',
        2500192111: 'e501b85c-52a7-48ef-834d-229326d8ef10',
        600001461712: 'c5668abf-e20a-4734-9d18-c922a6754023',
        600001847590: '3b4f8944-1c5f-4915-a127-baea7d1d48db'
    };

    export default {
        name: 'Home',
        data(){
            return {
                edlink: null
            };
        },
        computed: {
            authenticated(){
                return this.$store.state.user.id;
            },
            publisher(){
                return this.$store.getters.publisher;
            },
            integration(){
                return this.$store.getters.integration;
            },
            headline(){
                return this.publisher.data.headline ? this.publisher.data.headline : 'Sign in to access our digital resources.';
            }
        },
        created(){
            if(this.authenticated){
                this.$router.push('/library');
            }else{
                this.edlink = new EdlinkWidget({
                    client_id: clients[this.publisher.id],
                    redirect_uri: process.env.NODE_ENV === 'production' ? `https://${window.location.hostname}/api/login` : `http://localhost:9997/api/login`,
                    state: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
                });

                this.edlink.activatePlugin({
                    name: 'authentication'
                });

                this.edlink.show();
            }
        },
        methods: {
            serialize(object){
                const str = [];

                for(const [key, value] of Object.entries(object)){
                    str.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
                }

                return str.join('&');
            },
            login(){
                //Construct the authorization URL
                const parameters = {
                    client_id: clients[this.publisher.id],
                    redirect_uri: process.env.NODE_ENV === 'production' ? `https://${window.location.hostname}/api/login` : `http://localhost:9997/api/login`,
                    state: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
                    chat: 'disabled'
                };

                if(this.integration){
                    window.location = `https://ed.link/api/authentication/integrations/${this.integration.id}?${this.serialize(parameters)}`;
                }else{
                    window.location = `https://ed.link/sso/login?${this.serialize(parameters)}`;
                }
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    @provider-background-color: @f;

    h1
    {
        color: var(--primary-text-color);
    }

    h3
    {
        font-size: 30px;
        line-height: 36px;
        margin-bottom: 40px;
        color: var(--primary-text-color);
    }

    h4
    {
        margin-bottom: 30px;
        text-transform: uppercase;
        color: var(--secondary-text-color);
        font-weight: 600;
        font-size: 14px;
        line-height: 16px;
    }

    .logo
    {
        margin-bottom: 30px;

        img
        {
            width: 250px;
        }
    }

    .hero
    {
        height: 100vh;

        .graphic
        {
            background: url('~@/assets/gradient.svg') center center no-repeat;
            background-size: cover;
            flex: 0.5;

            &.publisher-600016620787
            {
                background-image: url('~@/assets/triangles.svg');
            }
        }

        .details
        {
            padding: 80px 100px;
        }

        .login-options
        {
            margin-top: 30px;
            margin-bottom: 100px;

            .button
            {
                margin-right: 20px;
                min-width: 120px;
            }
        }

        .tagline
        {
            max-width: 550px;
        }

        .disclaimer
        {
            color: var(--secondary-text-color);
            font-size: 13px;
            margin-right: 20px;
            text-decoration: none;
            border: 0;

            &:hover, &:active
            {
                color: var(--primary-text-color);
            }
        }
    }
</style>
